/**
 *
 * @param path     requestPath: survey/1/topics/3/questions/6/answers
 * @param inherit  state inherit path: ['survey','topics','questions','answers']
 */
import { findIndex } from 'utils/array';

export function surveyParser (path, inherit, root) {
  let pathArr = path.split('/');
  let targetId = pathArr.pop();
  let targetName = pathArr[pathArr.length-1];
  let parentIndex = findIndex(inherit, (item) => item === targetName);
  if (parentIndex ===0) {
    return {targetId, targetName};
  }
  let parentName = inherit[parentIndex-1];

  let index = findIndex(pathArr, (item) => item === parentName);
  pathArr = pathArr.slice(index).reverse();

  let targetArray = findTarget(pathArr, root);
  return {targetId, targetName, targetArray};
}

function findTarget (pathArr, target) {
  let temp = pathArr.pop();
  if (pathArr.length === 0) {
    if (!target[temp]) {
      target[temp] = [];
    }
    return target[temp];
  }
  return findTarget(pathArr, target[temp]);
}

export function findTargetByPath (path, target) {
  let pathArr = path.split('/');
  let targetName = pathArr.pop();
  if (pathArr.length === 0) {
    return {targetName, targetObj: target};
  }
  let targetObj = findTarget(pathArr.reverse(), target);
  return {targetName, targetObj};
}



/** WEBPACK FOOTER **
 ** ./src/redux/utils/pathParser.js
 **/